import { ReflectionProbe } from "../../../../d3/component/Volume/reflectionProbe/ReflectionProbe";
import { Sprite3DRenderDeclaration } from "../../../../d3/core/render/Sprite3DRenderDeclaration";
import { AmbientMode } from "../../../../d3/core/scene/AmbientMode";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Color } from "../../../../maths/Color";
import { Vector3 } from "../../../../maths/Vector3";
import { Vector4 } from "../../../../maths/Vector4";
export class WebReflectionProbe {
    constructor() {
        this._id = ++WebReflectionProbe._idCounter;
        this._updateMaskFlag = -1;
        this._shCoefficients = [];
        this._probePosition = new Vector3();
        this._ambientColor = new Color();
        this.shaderData = LayaGL.renderDeviceFactory.createShaderData();
    }
    needUpdate() {
        return this.updateMark != this._updateMaskFlag;
    }
    destroy() {
        this.bound = null;
        delete this._shCoefficients;
        delete this._ambientSH;
        this.shaderData.destroy();
        this.shaderData = null;
    }
    setAmbientSH(value) {
        this._ambientSH = value;
    }
    setShCoefficients(value) {
        this._shCoefficients.length = 0;
        value.forEach(element => {
            var v4 = new Vector4();
            element.cloneTo(v4);
            this._shCoefficients.push(v4);
        });
    }
    setProbePosition(value) {
        value && value.cloneTo(this._probePosition);
    }
    setreflectionHDRParams(value) {
        value && value.cloneTo(this._reflectionHDRParams);
    }
    setAmbientColor(value) {
        value && value.cloneTo(this._ambientColor);
    }
    applyRenderData() {
        this._updateMaskFlag = this.updateMark;
        let data = this.shaderData;
        if (!this.boxProjection) {
            data.removeDefine(Sprite3DRenderDeclaration.SHADERDEFINE_SPECCUBE_BOX_PROJECTION);
        }
        else {
            data.addDefine(Sprite3DRenderDeclaration.SHADERDEFINE_SPECCUBE_BOX_PROJECTION);
            data.setVector3(ReflectionProbe.REFLECTIONCUBE_PROBEPOSITION, this._probePosition);
            data.setVector3(ReflectionProbe.REFLECTIONCUBE_PROBEBOXMAX, this.bound.getMax());
            data.setVector3(ReflectionProbe.REFLECTIONCUBE_PROBEBOXMIN, this.bound.getMin());
        }
        if (this.ambientMode == AmbientMode.SolidColor) {
            data.removeDefine(Sprite3DRenderDeclaration.SHADERDEFINE_GI_LEGACYIBL);
            data.removeDefine(ReflectionProbe.SHADERDEFINE_GI_IBL);
            data.setColor(ReflectionProbe.AMBIENTCOLOR, this._ambientColor);
        }
        else if (this.iblTex && this._ambientSH) {
            data.addDefine(ReflectionProbe.SHADERDEFINE_GI_IBL);
            data.removeDefine(Sprite3DRenderDeclaration.SHADERDEFINE_GI_LEGACYIBL);
            if (this.iblTex) {
                data._setInternalTexture(ReflectionProbe.IBLTEX, this.iblTex);
                data.setNumber(ReflectionProbe.IBLROUGHNESSLEVEL, this.iblTex.maxMipmapLevel);
            }
            ;
            this.iblTexRGBD ? data.addDefine(Sprite3DRenderDeclaration.SHADERDEFINE_IBL_RGBD) : data.removeDefine(Sprite3DRenderDeclaration.SHADERDEFINE_IBL_RGBD);
            this._ambientSH && data.setBuffer(ReflectionProbe.AMBIENTSH, this._ambientSH);
        }
        else {
            data.removeDefine(Sprite3DRenderDeclaration.SHADERDEFINE_GI_LEGACYIBL);
            data.removeDefine(ReflectionProbe.SHADERDEFINE_GI_IBL);
        }
        data.setNumber(ReflectionProbe.AMBIENTINTENSITY, this.ambientIntensity);
        data.setNumber(ReflectionProbe.REFLECTIONINTENSITY, this.reflectionIntensity);
    }
}
WebReflectionProbe._idCounter = 0;
